import { defineStore } from "pinia";

export const useInscripcionStore = defineStore("peleador_evento", {
  state: () => ({
    // Paso 1: Datos personales
    nombre:          "",
    apellido:        "",
    email:           "",
    telefono:        "",
    fechaNacimiento: "",
    genero:          "",
    nacionalidad:    "",
    direccion:       "",   // texto libre: "Saltillo, Coahuila"
    foto:            null, // File — se guarda en IndexedDB, aquí solo referencia
    redes_sociales: {
      youtube:   "",
      facebook:  "",
      instagram: "",
      twitter:   "",
    },

    // Paso 2: Datos de combate
    peso_kg:     "",
    cinta:       "",
    equipo:      "",
    trayectoria: "",
  }),

  actions: {
    resetFormulario() {
      this.$reset()
    },
  },

  persist: true,
});